

  document.addEventListener("DOMContentLoaded", function() {

// code for new search option in header search start  -------
  const searchButton = document.querySelector(".open-search");
  const headerSearch = document.querySelector("details-modal.header__search details");
  if (searchButton && headerSearch) {
    searchButton.addEventListener("click", function() {
      headerSearch.setAttribute("open", "true"); // open the modal
      const input = headerSearch.querySelector("input[type='search']");
      if (input) input.focus(); // focus on input
    });
  }
  // code for new search option in header search end  -------



  
});